<script setup>
const props = defineProps({
  grid: Array,
  activeId: [Number, String],
});
</script>

<template>
  <div class="l-container">
    <div class="grid-tiles flex flex-wrap -mx-xs">
      <template v-for="layout in grid">
        <GridTypesLayout2x2
          v-if="layout.layout === 'layout2x2'"
          :type="layout?.type"
          :item="layout?.tile2x2 ?? null"
          :id="layout?.id ?? null"
          :title="layout?.title ?? null"
          :reviews="layout?.reviews ?? null"
          :activeId="activeId"
        />
        <GridTypesLayout2x1-2x1
          v-if="layout.layout === 'layout2x1_2x1'"
          :item1="layout?.tile2x1_1 ?? null"
          :item2="layout?.tile2x1_2 ?? null"
          :activeId="activeId"
        />
        <GridTypesLayout2x1-1x1-1x1
          v-if="layout.layout === 'layout2x1_1x1_1x1'"
          :item1="layout?.tile2x1 ?? null"
          :item2="layout?.tile1x1_1 ?? null"
          :item3="layout?.tile1x1_2 ?? null"
          :activeId="activeId"
        />
        <GridTypesLayout1x1-1x1-2x1
          v-if="layout.layout === 'layout1x1_1x1_2x1'"
          :item1="layout?.tile1x1_1 ?? null"
          :item2="layout?.tile1x1_2 ?? null"
          :item3="layout?.tile2x1 ?? null"
          :activeId="activeId"
        />
      </template>
    </div>
  </div>
</template>

<style></style>
